import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_rule_pb';
import ApiMessageTemplate from '@/model/MessageTemplate';

export default class MessageTemplate extends ApiMessageTemplate {
  static fromGrpcModel(o?: pbm.MessageTemplate): MessageTemplate {
    const messageTemplate = new MessageTemplate();

    messageTemplate.id = Number(o?.id ?? 0);
    messageTemplate.locale = o?.locale || undefined;
    messageTemplate.subject = o?.subject || undefined;
    messageTemplate.body = o?.body || undefined;

    return messageTemplate;
  }

  toGrpcModel(): pbm.MessageTemplate {
    return create(pbm.MessageTemplateSchema, {
      id: BigInt(this.id),
      locale: this.locale ?? '',
      subject: this.subject ?? '',
      body: this.body ?? '',
      accountId: 0n,
      campaignId: 0n,
      serviceId: 0n,
      tabId: 0n,
      messageTypeId: 0n,
      eventTypeId: 0n,
    });
  }
}
